import { apiClient } from "../api_NEXT";
import { api } from "./config";

export { MittwaldAPIV2Client } from "@mittwald/api-client-NEXT";

api.setupWithClient(apiClient);

export * from "./access/index.js";
export * from "./app/index.js";
export * from "./article/index.js";
export * from "./auth/index.js";
export * from "./backup/index.js";
export * from "./base/index.js";
export * from "./config/index.js";
export * from "./container/index.js";
export * from "./contract/index.js";
export * from "./conversation/index.js";
export * from "./cronjob/index.js";
export * from "./customer/index.js";
export * from "./database/index.js";
export * from "./domain/index.js";
export * from "./file/index.js";
export * from "./invoice/index.js";
export * from "./lib";
export * from "./mail/index.js";
export * from "./marketplace/index.js";
export * from "./newsletter/index.js";
export * from "./notifications/index.js";
export * from "./order/index.js";
export * from "./project/index.js";
export * from "./react/index.js";
export * from "./server/index.js";
export * from "./user/index.js";
export * from "./fyndr/index.js";
